import { render, staticRenderFns } from "./CompanyEditConstructionWorkersTab.vue?vue&type=template&id=5d058a2a"
import script from "./CompanyEditConstructionWorkersTab.vue?vue&type=script&lang=ts"
export * from "./CompanyEditConstructionWorkersTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports